import { choose } from '../../utils/platform';
import ContactSyncDesktop from './ContactSync.desktop';
import ContactSyncMobile from './ContactSync.mobile';

// Platform chooser — logic in useContactSync.
export default choose(ContactSyncDesktop, ContactSyncMobile);
